<template>
  <div class="card">
    <div class="card-body">
      <div class="d-flex with-button">
        <div class="p-2">
          <h1>사용자 관리</h1>
        </div>
        <div class="p-2 small bottom">
          총 <strong><span class="number mint">{{tableData.length}}</span></strong> 건
        </div>

        <div class="ml-auto p-2">
          <!-- <button type="button" class="btn btn-primary" @click="excelUpload">엑셀 업로드</button> -->
          <button type="button" class="btn mint" @click="goEdit(0)">+ 사용자 추가</button>
        </div>

      </div>

      <div class="d-flex">
        <div class="p-2 w-100">
          <div class="input-group search">
            <div class="input-group-prepend">
              <span class="input-group-text"><i class="fas fa-search"></i></span>
            </div>
            <input type="text" class="form-control" aria-describedby="basic-addon1" v-model.trim="search.search_text" @keyup.enter="retrieve" placeholder="아이디 / 사용자명 / 전화번호 / 소속">
            <div class="input-group-apend">
              <button type="button" class="btn btn-default" @click="retrieve">
                 검색
              </button>
            </div>
          </div>
        </div>
        <div class="p-2 search-detail" v-if="searchDetailVisible">
          <a href="#" class="arrowdown"><i class="fas fa-angle-double-down"></i></a>
        </div>
      </div>

    </div>
    <!-- 그리드 -->
    <stone-data-table
      :loading="searchLoading"
      :columns="tableColumns"
      :data="tableData"
      :table-props="defaultTableProps"
      @row-click="rowClickHandler">
    </stone-data-table>

    <el-dialog title="엑셀 업로드" :visible.sync="dialogFormVisible" width="70%" :before-close="handleClose">
      <div>
        <!-- <b-form-file ref="upload" action="https://jsonplaceholder.typicode.com/posts/" v-model="file" :state="Boolean(file)" accept="application/vnd.ms-excel" placeholder="파일 선택"></b-form-file> -->
        <el-upload
          ref="upload"
          accept="application/vnd.ms-excel"
          action="/api/user/excel/upload"
          :headers="fileHeaders"
          :limit="1"
          :auto-upload="false"
          :on-success="handleUploadSuccess"
          :on-error="handleUploadError"
          :before-upload="handleBeforeUpload">
          <el-button slot="trigger" size="small" type="primary">파일 선택</el-button>
          <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">파일 업로드</el-button>
          <a href="/static/file/SAMPLE_USER_UPLOAD_v1.0.xls" download><el-button style="margin-left: 10px;" size="small" type=""><i class="fa fa-file-excel"></i> 샘플 다운로드</el-button></a>
        </el-upload>
        <div class="card second-card">
          <div class="card-body">
            <div class="d-flex">
              <div class="p-2">
                <h2>업로드 결과 <span class="number mint">{{excelTableData.length}}</span></h2>
              </div>
              <div class="ml-auto p-2">
              </div>
            </div>
          </div>
          <stone-data-table
            :loading="excelLoading"
            :columns="excelTableColumns"
            :data="excelTableData"
            :table-props="excelTableProps"
            :page-size="emptyPageSize"
            :pagination-props="emptyPaginationProps">
          </stone-data-table>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">닫기</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>

import common from '@/modules/common'
// import circleImage from 'circle-image'

export default {
  name: 'M990201',
  mixins: [common.mixins],
  data () {
    return {
      tableData: [],
      tableColumns: [
        {label: '사용자코드', prop: 'user_info_seq', align: 'left', width: 80},
        {label: '아이디', prop: 'id', align: 'left', width: 120},
        {label: '사용자명', prop: 'name', align: 'left', width: 120},
        {label: '구분', prop: 'user_type_name', align: 'center', width: 80},
        {label: '전화번호', prop: 'phone', align: 'center', width: 100, formatter: this.columnFormatterPhone},
        {label: '소속', prop: 'school_name', align: 'left', width: 120}
      ],
      search: {
        search_text: '',
        user_name: '',
        user_group: 'manager'
      },
      dialogFormVisible: false,
      excelTableData: [],
      excelTableColumns: [
        {label: '사용자코드', prop: 'user_info_seq', align: 'left', width: 80},
        {label: '아이디', prop: 'id', align: 'left', width: 120},
        {label: '사용자명', prop: 'name', align: 'left', width: 120},
        {label: '전화번호', prop: 'phone', align: 'center', width: 100, formatter: this.columnFormatterPhone},
        {label: '소속', prop: 'school_name', align: 'left', width: 100},
        {label: '생년월일', prop: 'birthday', align: 'center', width: 100, formatter: this.columnFormatterDate},
        {label: '결과', prop: 'excel_msg', align: 'left', width: 100}
      ],
      excelTableProps: {height: 400, rowClassName: this.tableRowClassName},
      excelLoading: false,
      fileHeaders: {
        Authorization: '',
        Seq: 0
      },
      excelUploadVisible: false
    }
  },
  beforeCreate () {
  },
  created () {
    this.retrieve()
  },
  mounted () {
    this.fileHeaders.Authorization = this.$store.getters.access_token
    this.fileHeaders.Seq = this.$store.getters.user_seq
    // this.excelUploadVisible = this.$store.getters.user_id === 'ADMIN'
  },
  methods: {
    retrieve: function () {
      this.loadStoneDataTable('/user/list', this.search)
        .then(response => {
          this.tableData = response.data
        })
        .catch(() => {
        })
    },
    goEdit: function (userSeq) {
      const param = {
        user_info_seq: userSeq
      }
      const routerName = userSeq === 0 ? 'M990202' : 'M990203'
      this.$router.push({name: routerName, params: param})
    },
    rowClickHandler: function (row, event, column) {
      this.goEdit(row.user_info_seq)
    },
    excelUpload () {
      this.excelTableData = []
      this.excelLoading = false
      this.dialogFormVisible = true
    },
    submitUpload () {
      this.$refs.upload.submit()
    },
    handleUploadSuccess (res, file) {
      // console.log('res : ', res)
      // console.log('file : ', file)
      if (res) {
        this.$refs.upload.clearFiles()
        this.excelTableData = res
      }
      this.excelLoading = false
    },
    handleUploadError (err, file, fileList) {
      console.error('handleUploadError : ', err)
      this.excelLoading = false
    },
    handleBeforeUpload (file) {
      if (file.type === 'application/vnd.ms-excel') {
        this.excelLoading = true
        return true
      } else {
        this.$message.warning('파일을 선택하십시오.')
        return false
      }
    },
    handleClose () {
      const success = this.excelTableData.find(x => x.excel_code === 'S')
      this.$nextTick(() => {
        this.dialogFormVisible = false
        this.excelTableData = []
        if (success) {
          this.retrieve()
        }
      })
    },
    tableRowClassName ({row, rowIndex}) {
      return row.excel_code === 'S' ? 'success-row' : 'warning-row'
    },
    downloadSample () {

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .el-table .warning-row .stone-table-cell {
    background: oldlace !important;
  }
  .el-table .warning-row .stone-table-cell .cell {
    color: red;
  }
  .el-table .success-row .stone-table-cell {
    background: #f0f9eb !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/M990201.vue